import { classnames } from '@src/utils/classnames';
import React, { useContext } from 'react';
import { GroupBase } from 'react-select';
import { BreakpointsContext } from '../../../providers/Breakpoints';
import { IOptionBase, ISelectMenuPortalProps } from '../models';
import styles from './SelectMenuList.scss';

export const SelectMenuList = <
  OptionType extends IOptionBase,
  GroupType extends GroupBase<OptionType>,
  IsMulti extends boolean,
>({
  children,
  innerProps,
  selectProps,
}: React.PropsWithChildren<ISelectMenuPortalProps<OptionType, IsMulti, GroupType>>) => {
  const { maxMenuHeight, classNamePrefix } = selectProps;
  const classes = classnames(styles.root, classNamePrefix);
  const { isMobile } = useContext(BreakpointsContext);
  return (
    <div
      {...innerProps}
      className={classes}
      style={{ maxHeight: isMobile ? undefined : maxMenuHeight }}
      data-elem="select-menu-list"
    >
      {children}
    </div>
  );
};
